import { AssociationKeys } from '../utils/association.model';

export const ConferenceRegistrationEmergencyContactKeysToPick = [
  AssociationKeys.firstName,
  AssociationKeys.lastName,
  AssociationKeys.associationType,
  AssociationKeys.contactNumber,
] as const;
